<template>
    <div v-if="visible">
        <el-dialog title="设置学校组织" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="800px">    
            <el-table
                :data="depts"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                row-key="id"
                border
                lazy
                height="450"
                :load="load">
                <!-- <el-table-column type="index" :index="indexMethod" label="序号" width="50px"></el-table-column> -->
                <el-table-column prop="text" label="组织名称"></el-table-column>
                <el-table-column prop="attributes.nature" label="类型" width="100px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.attributes.nature == 1">
                            幼儿园
                        </div>
                        <div v-else-if="scope.row.attributes.nature == 2">
                            小学
                        </div>
                        <div v-else-if="scope.row.attributes.nature == 3">
                            中学
                        </div>
                        <div v-else-if="scope.row.attributes.nature == 0">
                            其他
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="attributes.deptControllerName" label="学校负责人" width="100px"></el-table-column>
                <el-table-column fixed="right" label="操作" width="130px">
                    <template slot-scope="scope">
                         <el-button @click.native.prevent="setAdd(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">新增</span>
                        </el-button>
                        <el-button  v-if="scope.row.parentId != 0" @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>

                        <el-dropdown   v-if="scope.row.parentId != 0"  trigger="click" @command="(cmd) => handleMoreCommand(cmd, scope.row)">
                            <span class="el-dropdown-link" style="color: #387EE8;cursor: pointer;">
                                更多<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="dispatchCoupon" v-if="showDispatchCoupon(scope.row)">派发优惠券</el-dropdown-item>
                                <el-dropdown-item command="dispatchRecord" v-if="showDispatchCoupon(scope.row)">查看派发记录</el-dropdown-item>
                                <el-dropdown-item command="delete" style="color: red;">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
        <!-- 派发优惠券弹出框 -->
        <div v-if="dispatchCouponVisible">
            <dispatchCoupon ref="dispatchCoupon"></dispatchCoupon>
        </div>
        <!-- 查看派发记录弹出框 -->
        <div v-if="dispatchRecordVisible">
            <dispatchCouponRecord ref="dispatchCouponRecord" @closed="dispatchRecordVisible=false"></dispatchCouponRecord>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import add from './Add.vue'; 
    import update from './SetSchoolDeptUpdate.vue'; 
    import dispatchCoupon from './DispatchCoupon.vue';
    import dispatchCouponRecord from './DispatchCouponRecord.vue';

    export default {
        components:{
            add,update,dispatchCoupon,dispatchCouponRecord
        },
        data(){
            return{
                loading:false,
                visible: false,
                addVisible:false,
                updateVisible:false,
                dispatchCouponVisible:false,
                dispatchRecordVisible:false,
                querForm:{
                    id:"", //组织ID
                    schoolId: "", // 学校ID
                },
                depts:[],
                isAdmin: false
            }
        },
        created() {
            const userinfo = JSON.parse(sessionStorage.getItem('userinfo'));
            this.isAdmin = userinfo && userinfo.id == 1;
        },
        methods:{
            init(data){
                this.visible = true
                this.querForm.schoolId = data.id
                this.getData()
            },
            getData(){
                this.loading=true
                let url  = this.deptSetSchoolDeptUrl
                let data = {
                    schoolId: this.querForm.schoolId
                }
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data.depts));
                    if(res.status == 200){
                       this.depts = res.data.depts
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
            // 新增界面
            setAdd(data){
                this.addVisible = true;
                this.$nextTick(() => {
                    this.$refs['add'].init(data);
                })
            },
            // 修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            showDispatchCoupon(row){
                if (!this.isAdmin) {
                    return false;
                }
                let name = this.$util.isNotEmpty(row) ? row.text : '';
                if(this.$util.isEmpty(name)){
                    return false;
                }
                return name.indexOf('年级') > -1 || name.indexOf('班') > -1;
            },
            // 派发优惠券
            setDispatchCoupon(row){
                this.dispatchCouponVisible = true;
                this.$nextTick(() => {
                    this.$refs['dispatchCoupon'].init({
                        orgId: row.id,
                        orgName: row.text
                    });
                })
            },
            // 查看派发记录
            openDispatchRecord(row){
                this.dispatchRecordVisible = true;
                this.$nextTick(() => {
                    this.$refs['dispatchCouponRecord'].init({
                        orgName: row.text
                    });
                })
            },
            handleMoreCommand(cmd,row){
                if(cmd === 'dispatchCoupon'){
                    if (!this.isAdmin) {
                        return;
                    }
                    this.setDispatchCoupon(row);
                }else if(cmd === 'dispatchRecord'){
                    if (!this.isAdmin) {
                        return;
                    }
                    this.openDispatchRecord(row);
                }else if(cmd === 'delete'){
                    this.del(row);
                }
            },
            // 删除
            del(data){
                this.querForm.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.deptDelUrl;
                let data = {
                    id:this.querForm.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip("删除成功",1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            dialogClose(done){
                done()
                this.$parent.getData()
            },
            load(tree, treeNode, resolve) {
                console.log('加载数据...')
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/sys/dept/SetSchoolDept.vue